


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import { CardType, LinkConfig } from '../../../entities/conversation'

interface Option {
    key: CardType
    value: string
    description: string
    ispro?: boolean
}

interface CardTypeCounts {
    listcount: number
    questioncount: number
    commentcount: number
}

@Component<CardTypeSelector>({})
export default class CardTypeSelector extends Vue {

    @Prop(String) public type!: CardType
    @Prop(Boolean) public inline?: boolean
    @Prop(Boolean) public disableJump?: boolean
    @Prop(Boolean) public hasScorecardFeature!: boolean

    @Getter public getCardTypes!: CardTypeCounts
    @Getter public getHasFlows!: boolean
    @Getter public getIsBasic!: boolean
    @Getter public getMaxListItems!: number
    @Getter public getCalendly!: LinkConfig
    @Getter
    $companyVars

    @Action public setShowUpgrade!: (boolean) => void
    @Action public setClickCardType!: (string) => void

    public open = false

    private baseOptions: Option[] = [
        {
            key: 'message',
            value: 'Message',
            description: 'Say something only. This won\'t get a reply.'
        },
        {
            key: 'question',
            value: 'Open Question',
            description: 'Ask a question and allow for a reply.',
            ispro: true

        },
        {
            key: 'list',
            value: 'List Question',
            description: 'Ask a question and supply a list of reply options.',
            ispro: true
        },
        // todo scorecard3 update key directly to v3
        {
            key: 'scorecard',
            value: 'Scorecard Question',
            description: 'Ask a list question with predefined badge options.',
            ispro: true

        },
        {
            key: 'csat',
            value: 'CSAT Question',
            description: 'Ask a question and receive specific "Very Unsatisfied" to "Very Satisfied" reply options.',
            ispro: true
        },
        {
            key: 'ces',
            value: 'CES Question',
            description: 'Ask a question and receive specific "Strongly Agree" to "Strongly Disagree" reply options.',
            ispro: true
        },
        {
            key: 'nps',
            value: 'NPS Question',
            description: 'Ask a question and receive a 0-10 score. Does not affect your primary NPS score.',
            ispro: true
        }
    ]

    public get options() {
        // todo scorecard3 update above key directly to v3
        if (this.$companyVars.has_scorecard_v3) {
            const option = this.baseOptions.find(option => option.key === 'scorecard')
            if (option) {
                option.key = 'scorecardv3'
            }
        }
        const opts: Option[] = this.baseOptions.filter(
            (option) => this.hasScorecardFeature || option.key !== 'scorecard'
        )
        const cardTypeCount = this.getCardTypes

        this.baseOptions.map( (option) => {
            if (option.key === 'list' && this.getIsBasic) {
               option.ispro = ( cardTypeCount.listcount >= this.getMaxListItems )
            } else if (option.key === 'question' && this.getIsBasic) {
                // We alway allow one question, of type comment.
                // If you have the comment, then mark new questions in the list as pro (eg disabled).
                option.ispro = ( cardTypeCount.commentcount >= 1 )
            } else {
                if (option.ispro) {
                    option.ispro = this.getIsBasic // Basic is on = show pro, if basic is off remove pro feature.
                }
            }
            return option
        })

        if (this.getCalendly) {
            opts.push(
                {
                    key: 'external',
                    value: 'Calendly Link',
                    description: 'Add a calendly link for your customer to schedule a call.',
                    ispro: this.getIsBasic
                }
            )
        }

        if (!this.disableJump && this.getHasFlows) {
            return [...opts, {
                key: 'jump',
                value: 'Jump',
                description: 'Add logic to jump to another flow',
                ispro: this.getIsBasic
            }]
        }
        return opts
    }

    public mounted() {
        if (this.inline) {
            this.open = true
        }
    }

    public cancelCard() {
        this.$emit('cancel')
    }

    public get activeLabel() {
        const active = this.options.find(({ key }) => key === this.type)
        return active && active.value
    }

    public handleOptionClick(cardType: CardType, ispro: boolean) {
        if (ispro) {
            this.setShowUpgrade(true)
            this.setClickCardType(cardType)
            return
        }

        if (cardType !== 'unknown' && this.type !== cardType) {
            this.$emit('change', cardType)
        }
        this.open = false
    }
}
